/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'inferno-redux';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import SelectSet from 'components/content/shared/questionset/select/select';
import { setAnswerClicked, advanceFrame, requestQuestionResponseResult } from 'redux/actions/content_status';
import { displayScreen } from 'redux/actions/screen_status';
import { awardPoints, awardPointsWithRewards } from 'redux/actions/rewards';
import { showLoader } from 'redux/actions/embed_status';



/* ========== ~~~~~~~~~~ SelectSet : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ settings, contentStatus, queueStatus, contentData, rewards, sessionStatus }, { contentId, frameData, isCorrectAnswer, frame }) => ({
    currentContentStatus: contentStatus[contentId],
    currentContentSettings: settings.contentSettings[contentId],
    embedUUID: settings.embedSettings.embedUUID,
    siteUUID: settings.embedSettings.site.uuid,
    currentUniqueState: contentStatus[contentId].uniqueState,
    currentContentData: contentData[contentId],
    rewardsSettings: rewards.settings,
    rewardsStatus: rewards.status,
    userInfo: sessionStatus.userInfo,
    frameData: !!contentId ? contentData[contentId].data[contentStatus[contentId].frame] : null,
    frameStatus: !!contentId ? contentStatus[contentId].uniqueState.frameStatus[frame] : null,
    isPubPortalPreview: settings.embedSettings.isPubPortalPreview
});


const mapDispatchToProps = dispatch => ({
    setAnswerClicked: (contentId, frame, predictionOptionUUID) => dispatch(setAnswerClicked(contentId, frame, predictionOptionUUID)),
    awardPoints: (numberOfPoints) => dispatch(awardPoints(numberOfPoints)),
    awardPointsWithRewards: (numberOfPoints, numberOfRewards, rewardsPhase) =>
        dispatch(awardPointsWithRewards(numberOfPoints, numberOfRewards, rewardsPhase)),
    displayScreen: (screen) => dispatch(displayScreen(screen)),
    advanceFrame: contentId => dispatch(advanceFrame(contentId)),
    requestQuestionResponseResult: (contentId, frame, isFactualQuestion, responseDetails, isPubPortalPreview) =>
        dispatch(requestQuestionResponseResult(contentId, frame, isFactualQuestion, responseDetails, isPubPortalPreview)),
    showLoader: state => dispatch(showLoader(state))
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
// will be utilized from any component that wants to incorporate "Content" component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SelectSet);
